<template>
  <v-container>
    <v-row
      text-xs-center
      wrap
    >
      <v-col
        mb-5
        xs12
      >
        <h2 class="text-center grey--text headline font-weight-bold mb-3">
          Om forskningsprojektet
        </h2>

        <v-row justify="center">
          <a
            v-for="(next, i) in links"
            :key="i"
            :href="next.href"
            class="subheading mx-3"
            target="_blank"
          >{{ next.text }}</a>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'About',
  components: {
  },
  data: () => ({
    links: [
      {
        text: 'Databeskyttelse',
        href: 'https://kp.dk',
      },
      {
        text: 'Formål og design',
        href: 'https://kp.dk',
      },
      {
        text: 'Kontakt',
        href: 'https://kp.dk',
      },
    ],
  }),
}
</script>

<style></style>
